import React from 'react'
import { Routes, Route } from 'react-router-dom'
import LayoutWrapper from './components/LayoutWrapper'
import Layout from './components/Layout'
import Login from './features/auth/Login'
import RequireAuth from './features/auth/RequireAuth'

const App = () => {

  return (
    <React.Fragment>
      <Routes>
        <Route path="/" element={<LayoutWrapper />}>
          {/* public routes */}
          <Route index element={<Login />} />
          <Route path="/login" element={<Login />} />

          {/* protected routes */}
          <Route element={<RequireAuth />}>
            <Route path="/home/*" element={<Layout />} />
          </Route>
        </Route>
      </Routes>
    </React.Fragment>
  )
}

export default App;
